import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './libs/filters'
import * as ModalDialogs from 'vue-modal-dialogs'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle'

Vue.config.productionTip = false
Vue.use(ModalDialogs)

Vue.component('UiLoadingCircle', UiLoadingCircle)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
